module.exports = __webpack_public_path__ + "static/media/course_logo.37c39af1.png";